import React from 'react';
import { Col, Card, CardBody, Pagination, PaginationItem, PaginationLink } from 'reactstrap';

import { PaginationSizing, Previous, Next } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';

const PaginationSizingClass = () => {
  return (
    <Col xl='6'>
      <Card>
        <HeaderCard title={PaginationSizing} />
        <CardBody>
          <Pagination listClassName='pagination-lg pagination-primary' className='m-b-30' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
          <Pagination listClassName='pagination-sm pagination-primary' aria-label='Page navigation example'>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink href='#javascript'>{Next}</PaginationLink>
            </PaginationItem>
          </Pagination>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PaginationSizingClass;
